// entities.js
export const STATE_ENTITIES = {

  AUTH: {
    LOGIN: "login",
    REGISTER: "register",
  },
  ADMIN: {
    DASHBOARD: "dashboard",
  },
  DESIGNATION: {
    READ: "designation_read",
    CREATE: "designation_create",
    UPDATE: "designation_update",
    DELETE: "designation_delete",
  },
  PAGE: {
    READ: "page_read",
    READ_ONE: "page_read_one",

    CREATE: "page_create",
    UPDATE: "page_update",
    DELETE: "page_delete",
    
  },
  USER: {
    READ: "user_read",
    CREATE: "user_create",
    UPDATE: "user_update",
    DELETE: "user_delete",
    NEWSLETTER_SUBSCRIBE : "newsletter_subscribe",
    CONTACT_US : "contact_us"
    

  },
  STATUS_CATEGORY: {
    READ: "statusCategory_read",
    CREATE: "statusCategory_create",
    UPDATE: "statusCategory_update",
    DELETE: "statusCategory_delete",
  },
  GLOBAL: {
    STATE_CITY: "state_city",
    ADVERT: "advert",

  },
  VENUE: {
    ONBOARDING: "onboarding",
    TOP_CATEGORIES: "top_categories",
    TOP_LOCATIONS: "top_locations",
    LIST: "list",
    DETAIL: "detail",
    FILTER: "filter",
    SEARCH_BY_NAME : "search_by_name",
BOOKING_REQUEST: "booking_request",
BIDING_REQUEST: "biding_request",

  },

  ANCILLARY_SERVICE: {
    ONBOARDING: "onboarding",
    CONTACT_US: "contact_us",

    LIST: "list",
    DETAIL: "detail",
    FILTER: "filter",
    REQUEST_PRICE_ESTIMATE : "request_price_estimate",
    MAKE_FAVORITE : "make_favorite",


  },

  
};
